module.exports = __webpack_public_path__ + "img/xmasParty4.7258c8ce.jpg";